function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.7409682-.73975512h2.7129128v52.34614152h-2.7129128z",
  transform: "matrix(-.86601905 -.500011 .500011 -.86601905 19.187183 56.007953)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.297866 43.799796h52.347293v2.712972h-52.347293z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.98651716 50.3514742h30.23426844v2.7129127h-30.23426844z",
  transform: "matrix(-.86601905 -.500011 .500011 -.86601905 6.061204 105.039998)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.7320779 10.9514333h30.2342685v2.7129128h-30.2342685z",
  transform: "matrix(-.86601905 -.500011 .500011 -.86601905 68.205308 42.891802)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.7544514-2.81957344h2.7129127v30.23426844h-2.7129127z",
  transform: "matrix(-.500011 -.86601905 .86601905 -.500011 15.016628 33.264849)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.6947563 24.0773496h52.3461415v2.7129127h-52.3461415z",
  transform: "matrix(-.500011 -.86601905 .86601905 -.500011 37.776019 72.677287)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.373453 16.882533h2.712972v30.234934h-2.712972z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.872943 16.882533h2.712972v30.234934h-2.712972z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.6642413 38.5450247h2.3697129v26.2956421h-2.3697129z",
  transform: "matrix(-.500011 -.86601905 .86601905 -.500011 15.007096 112.049916)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56.1814205 48c-1.5689479 2.7293156-5.0663943 3.6608784-7.7957099 2.0919305s-3.6608784-5.0663942-2.0919305-7.7957099c1.5689479-2.7293156 5.0663943-3.6608784 7.7957099-2.0919305 2.7456588 1.5852911 3.6772216 5.0663943 2.0919305 7.7957099"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.6492448 21.7037794c-1.56894787 2.7293156-5.06639424 3.6608784-7.79570987 2.0919305s-3.66087845-5.0663943-2.09193054-7.7957099c1.5689479-2.7293156 5.06639428-3.6608784 7.79570991-2.0919305 2.7293156 1.5852911 3.6608784 5.0663942 2.0919305 7.7957099"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.7779476 48c-1.56894791-2.7293156-.63738509-6.2104188 2.09193054-7.7957099 2.72931563-1.5689479 6.21041879-.6373851 7.79570986 2.0919305 1.568948 2.7293157.6373851 6.2104188-2.0919305 7.7957099-2.74565883 1.5689479-6.226762.6373851-7.7957099-2.0919305"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46.3101233 21.7037794c-1.5689479-2.7293157-.6373851-6.2104188 2.0919305-7.7957099 2.7293157-1.5689479 6.2104188-.6373851 7.7957099 2.0919305 1.5689479 2.7293156.6373851 6.2104188-2.0919305 7.7957099-2.7293156 1.5689479-6.226762.6373851-7.7957099-2.0919305"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.4796841 64c-3.1542391 0-5.7037794-2.5495403-5.7037794-5.7037794 0-3.154239 2.5495403-5.7037793 5.7037794-5.7037793 3.154239 0 5.7037793 2.5495403 5.7037793 5.7037793 0 3.1378958-2.5495403 5.7037794-5.7037793 5.7037794"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.4796841 11.4075587c-3.1542391 0-5.7037794-2.54954031-5.7037794-5.70377933s2.5495403-5.70377937 5.7037794-5.70377937c3.154239 0 5.7037793 2.54954035 5.7037793 5.70377937s-2.5495403 5.70377933-5.7037793 5.70377933"
}));

function SvgIconGraphql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 57 64",
    width: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphql);
export default __webpack_public_path__ + "static/media/icon-graphql.62e7c0bb.svg";
export { ForwardRef as ReactComponent };